<p-toast [style]="{marginTop: '80px'}"></p-toast>

<div class="p-grid">
    <div class="p-col-12 map">
        <div class="map-container">
            <div class="map-frame">
                <div id="map"></div>
            </div>
        </div>
    </div>
    <div class="p-col-4">
        <div class="card map-card_options" style="overflow: hidden;">
            <div class="p-grid">
                <div class="p-col-12">
                    <div class="p-d-flex p-ai-left p-jc-between">
                        <button style="background-color: white; color: black;" type="button" pButton
                            icon="pi pi-globe"></button>
                        <button style="background-color: white; color: black;" type="button" pButton
                            icon="pi pi-home"></button>
                        <button style="background-color: white; color: black;" type="button" pButton
                            icon="pi pi-user"></button>
                        <button style="background-color: white; color: black;" type="button" pButton
                            icon="pi pi-plus"></button>
                        <button style="background-color: white; color: black;" type="button" pButton
                            icon="pi pi-minus"></button>
                    </div>
                </div>
            </div>
        </div>
        <div class="card map-card_detail" style="overflow: hidden;">
            <div class="p-grid">
                <div class="p-col-12">
                    <div class="p-fluid">
                        <div class="p-col-12">
                            <label for="statusModal">Identificador</label>
                            <input id="selectedNameInput" value="0000666584" disabled="true" type="text" maxlength="30"
                                pInputText placeholder="Seleccione un lenguaje">
                        </div>
                        <div class="p-col-12">
                            <label for="statusModal">Coordinación </label>
                            <input id="selectedNameInput" value="Internacional" disabled="true" type="text"
                                maxlength="30" pInputText placeholder="Seleccione un lenguaje">
                        </div>
                        <div class="p-col-12">
                            <label for="statusModal">Dirección</label>
                            <input id="selectedNameInput" value="Calle #12 Av. 16 Septiembre" disabled="true"
                                type="text" maxlength="30" pInputText placeholder="Seleccione un lenguaje">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card map-card">
            <p-table #dt [columns]="cols" [value]="data" [paginator]="true" [rows]="rowsPerPage"
                [showCurrentPageReport]="false" [globalFilterFields]="colsGlobal">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                            {{ capitalizeLastElement(col.header) }}
                            <p-sortIcon [field]="col.field"></p-sortIcon>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr>
                        <td *ngFor="let col of columns">
                            {{ getNestedValue(rowData, col.field) }}
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>